import { TenderingActions } from 'src/common/redux/reducers/tendering-reducer';
import {
  cancelItem,
  cancelLine,
} from '../../../../src/home-page/business-logic/cancel-line-or-item';
import { IItemInputData } from '../../../common/interfaces/IItemInputData';
import { store } from '../../../common/redux/configure-store';
import { addItemToTransaction } from '../../../home-page/business-logic/sale-mode-router';

export const OWN_BAG_MODAL_ID = 'OWN_BAG_MODAL';

export const updateLineItemQuantity = async (inputData: IItemInputData): Promise<void> => {
  const items = store
    .getState()
    .itemList.ejItems.filter(i => i.ItemId === inputData.itemId && !i.Voided);

  if (!inputData.quantity) {
    inputData.quantity = 0;
  }

  if (items.length === 0 && inputData.quantity === 0) {
    // 0 bags added and no previous bags found.
    store.dispatch(TenderingActions.setIsOwnBagDisabled(true));
  }

  inputData.quantity -= items.reduce((state, i) => (state += i.Quantity || 0), 0);

  if (inputData.quantity <= 0) {
    let delta = Math.abs(inputData.quantity);
    const sortedItems = items.sort((a, b) => ((a.Quantity || 0) < (b.Quantity || 0) ? -1 : 1));
    for (let i = 0; i < sortedItems.length; i++) {
      const item = items[i];
      const quantity = item.Quantity || 0;

      if (quantity <= delta) {
        await cancelLine(item);
      } else {
        await cancelItem(item, delta);
      }
      delta -= quantity;
      if (delta <= 0) {
        break;
      }
    }
  } else {
    await addItemToTransaction(inputData);
  }
};
